<template>
    <q-page>
        <div class="q-display-1">Kategorie</div>

        <category-entry
            v-for="category in categories"
            :key="category.category"
            :model="category"
            />

        <fixed-buttons>
            <q-btn
                flat
                style="font-size: 1.5rem" dense
                icon="add_circle"
                color="primary"
                @click="add">
                <q-tooltip anchor="top left">
                    Dodaj nową
                </q-tooltip>
            </q-btn>
        </fixed-buttons>
    </q-page>
</template>

<script>
    import FixedButtons from './FixedButtons'
    import QBtn from 'quasar-framework/src/components/btn/QBtn'
    import QTooltip from 'quasar-framework/src/components/tooltip/QTooltip'
    import ActivityComponent from './ActivityComponent'
    import CategoryEntry from './CategoryEntry'
    export default {
        name: 'Categories',
        components: {CategoryEntry, ActivityComponent, QTooltip, QBtn, FixedButtons},
        mounted () {
            this.$emit('showRightMenu', {
                showPictures: true
            })
        },
        computed: {
            categories () {
                return this.$store.getters.category
            }
        },
        methods: {
            add () {
                this.$q.dialog({
                    title: 'Podaj nazwę nowej kategorii',
                    prompt: {
                        model: '',
                        type: 'text'
                    },
                    cancel: true,
                    color: 'secondary'
                }).then(data => {
                    if (data && data.length > 0) {
                        const id  = this.$uuid()

                        this.$store.dispatch('create', {
                            what: 'category',
                            item: {
                                category: id,
                                label: data,
                                description: data
                            },
                            id
                        }).then(() => {
                            this.localCategory = id
                        })
                    } else {
                        this.$q.notify('Nazwa nie może być pusta')
                    }
                })

            }
        }
    }
</script>